<template>
	<div class="identify-container h100" v-loading="loginLoading"></div>
</template>

<script>
	import { getUrlParams } from "@/assets/js/until";
	import { mapMutations } from "vuex";
	export default {
		name: "Login",
		data() {
			return {
				idToken: "",
				loginLoading: true,
			};
		},
		mounted() {
			let urlParams = getUrlParams(window.location.href);
			if (urlParams.id_token) {
				this.idToken = urlParams.id_token;
				this.oaAuthLogin();
			}
		},
		methods: {
			...mapMutations([
				"setUserName",
				"setAppID",
				"setAccessToken",
				"setPermissions",
				"setAuthMap",
			]),
			oaAuthLogin() {
				let url = this.getApiUrl("oaAuth");
				let p = {
					idToken: this.idToken,
				};
				this.loginLoading = true;
				this.axios
					.post(url, p, { pure: true })
					.then((res) => {
						let { code, msg, data } = res;
						console.log(code);
						if (code === 1) {
							if (data?.admin) {
								localStorage.setItem(
									"admin",
									JSON.stringify(data?.admin)
								);
							}
							data.userName = data.admin.loginName || "";
							this.saveLoginData(data);
							let domain =
								process.env.NODE_ENV === "prod"
									? ".miaohealth.net"
									: location.hostname;
							window.$setCookie(
								"token",
								data.token,
								10,
								"/",
								domain,
								false
							);
							window.$setCookie(
								"username",
								data.admin.loginName || "",
								10,
								"/",
								domain,
								false
							);
							this.$root.setUserInfo();
							this.$root.token = data.token;
							if (data.permission.indexOf("sa_statics_home") == -1) {
								this.$router.push({ path: "/welcome" });
							} else {
								this.$router.push({ path: "/home" });
							}
							this.loginLoading = false;
						} else {
							this.$message.warning(msg);
							this.$router.push({ path: "/login" });
						}
					})
					.catch((err) => {
						this.$message.error("登录失败");
						// this.loginLoading = false;
						console.log(err);
					});
			},
			//保存登录信息
			saveLoginData({ token, permission = "22", userName }) {
				this.setUserName(userName);
				this.setAccessToken(token);
				if (permission) {
					// 删除首尾的|字符
					let _permission = permission.substring(
						1,
						permission.length - 1
					);
					let permissions = _permission.split("|");
					this.setPermissions(permissions);
					let map = {};
					permissions.forEach((item) => {
						map[item] = true;
					});
					this.setAuthMap(map);
				} else {
					this.setPermissions([]);
					this.setAuthMap({});
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../assets/css/color.scss";
</style>
